import api from '@pray/shared/utils/api';

import type { UpdateReportResponse } from './data/response';
import type { UpdateReportRequest } from './data/types';

type UpdateReportProps = {
  artistId: string;
  reportId: string;
  data: UpdateReportRequest;
};

export async function updateReport({ artistId, reportId, data }: UpdateReportProps): Promise<UpdateReportResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!reportId) throw new Error('Report ID is required');

  const url = `/web/studio/artists/${artistId}/reports/${reportId}`;

  const response = await api.executePatchRequest<UpdateReportResponse>(url, data);
  return response.data;
}
